// extracted by mini-css-extract-plugin
export default {"root":"UserAvatar_root__VeXF4","image":"UserAvatar_image__5yZD6","initials":"UserAvatar_initials__f2ok4"};